export const ro = {
  Account: 'Cont',
  Active: 'Activ',
  Action: 'Acțiuni',
  Add: 'Adaugare',
  Administration: 'Administrare',
  Agents: 'Agenti',
  Author: 'Autor',
  AI: 'AI',
  Body: 'Cuprins',
  Cancel: 'Anulare',
  Chatbot: 'Chatbot',
  KnowledgeBase: 'Bază de Cunoștințe',
  KnowledgeBases: 'Baze de Cunoștințe',
  KnowledgeBaseItems: 'Elemente Bază de Cunoștințe',
  Chatbots: 'Chatboti',
  Clone: 'Cloneaza',
  Collapse: 'Micsoreaza',
  Config: 'Configuratie',
  Connectors: 'Conectori',
  Content: 'Continut',
  Copy: 'Copiaza',
  CopyClipboard: 'Copiaza in Clipboard',
  Database: 'Baze de date',
  Databases: 'Baze de date',
  Roles: 'Roluri',
  Date: 'Data',
  Debug: 'Debug',
  Delete: 'Stergere',
  DeleteMessage: 'Sunteti sigur ca vreti sa stergeti?',
  Download: 'Descarca',
  Edit: 'Editare',
  Email: 'Email',
  Emails: 'Emailuri',
  EmailSorters: 'Sortatoare Email',
  Execution: 'Executie',
  Executing: 'Executarea',
  Execute: 'Executa',
  Success: 'Succes',
  'Email Inbox': 'Inbox Email',
  'Email Message': 'Mesaj Email',
  'Email Messages': 'Mesaje Email',
  'Email processed successfully': 'Email procesat cu succes',
  Dashboard: 'Panou',
  'AI Account': 'Cont AI',
  'AI Connector': 'Conector AI',
  'AI Connectors': 'Conectori AI',
  'AI Max Tokens': 'AI Max Tokeni',
  'AI Context': 'Context AI',
  Copied: 'Copiat in clipboard!',
  'Executions scheduler': 'Planificare execuții',
  'Dry Run': 'Dry Run',
  'in preview mode': 'in modul previzualizare',
  'Use custom chatbot content': 'Folosiți continut chatbot personalizat',
  'New task scheduler': 'Programator nou de sarcini',
  'Use custom email content': 'Utilizați conținut personalizat de e-mail',
  'Custom Email Content': 'Conținut personalizat de e-mail',
  'Email Subject': 'Subiect Email',
  'Email Content': 'Conținut Email',
  'Recur every days': 'Se repetă în fiecare zi',
  'Include reply': 'Include Răspuns',
  'Set spam': 'Setează ca spam',
  'Reply sender': 'Răspuns expeditor',
  'Mark as read': 'Marchează ca citit',
  'Type Id': 'Tip Id',
  'First name': 'Prenume',
  'Last name': 'Nume',
  'AI Model': ' Model AI',
  'AI Temperature': 'Temperatura AI',
  Expand: 'Mareste',
  Enabled: 'Activat',
  From: 'Din',
  Forward: 'Redirecţionare',
  forwardTo: 'Transmite',
  Hide: 'Ascunde',
  Home: 'Acasa',
  Kit: 'Kit',
  Kits: 'Kit-uri',
  Needs: 'nevoi',
  Language: 'Limba',
  Logs: 'Loguri',
  Name: 'Nume',
  name: 'Nume',
  now: 'acum',
  Messages: 'Mesaje',
  Password: 'Parola',
  Permissions: 'Permisiuni',
  Phone: 'telefon',
  Preview: 'Previzualizare',
  Process: 'Proceseaza',
  Results: 'Rezultate',
  Robots: 'Roboti',
  Robot: 'Robot',
  Options: 'Opțiuni',
  Role: 'Rol',
  OneDrive: 'OneDrive',
  Reply: 'Raspuns',
  replyTo: 'Raspunde la',
  Running: 'Ruleaza',
  Run: 'Ruleaza',
  Search: 'Cautare',
  Schedule: 'Planificare',
  Scheduler: 'Planificări',
  Show: 'Afiseaza',
  Subject: 'Subiect',
  Start: 'Porneste',
  Storage: 'Stocare',
  Stop: 'Opreste',
  Submit: 'Salveaza',
  System: 'Sistem',
  Tasks: 'Activitati',
  Task: 'Activitate',
  Test: 'Testează',
  Theme: 'Tema',
  Thread: 'Conversatia',
  Threads: 'Conversatii',
  To: 'La',
  Type: 'Tip',
  Yes: 'Da',
  No: 'Nu',
  Update: 'Editeaza',
  Upload: 'Incarca',
  User: 'Utilizator',
  Users: 'Utilizatori',
  View: 'Vizualizeaza',
  'Schedule Email': 'Planificator email',
  Recruiter: 'Recruter',
  Recruiters: 'Recruteri',
  Resumes: 'CV-uri',
  Resume: 'CV',
  OneDrive: 'OneDrive',
  'OneDrive Share': 'OneDrive Share',
  'OneDrive Shares': 'Distribuiri OneDrive',
  'GoogleDrive Share': 'GoogleDrive Share',
  'Google Drive Share': 'GoogleDrive Share',
  'Google Drive': 'Google Drive',
  'GoogleDrive Shares': 'Distribuiri Google Drive',
  Retrieve: 'Incarca',
  resume: 'CV',
  resumes: 'CV-uri',
  Server: 'Server',
  Servers: 'Servere',
  Error: 'Eroare',
  matchesCriteria: 'Corespunde Criteriilor',
  firstName: 'Prenume',
  lastName: 'Nume',
  birthDate: 'Data Nasterii',
  email: 'Email',
  phone: 'Telefon',
  facebook: 'Facebook',
  twitter: 'Twitter',
  instagram: 'Instagram',
  linkedin: 'Linkedin',
  github: 'Github',
  website: 'Site-ul web',
  interests: 'Interese',
  address: 'Adresa',
  city: 'Oras',
  gender: 'Gen',
  nativeLanguage: 'Limba Nativa',
  skills: 'Abilitati',
  experience: 'Experienta',
  education: 'Educatie',
  potentialJobTitles: 'Titluri potentiale de post',
  seniorityLevel: 'Nivel Senioritate',
  jobChangeFrequency: 'Frecventa schimbarii locului de munca',
  yearsOfExperience: 'Ani Experienta',
  containsPhoto: 'Contine fotografie',
  matchingPercentage: 'Procent de potrivire',
  explanation: 'Explicatie',
  URL: 'URL',
  'URL Connector': 'Conector URL',
  'URL Connectors': 'Conectori URL',
  'Manage URLs': 'Gestionare URL-uri',
  'Start Crawl': 'Începe Scanarea',
  'Refresh Status': 'Actualizează Starea',
  Status: 'Stare',
  Crawling: 'Scanează',
  Ready: 'Pregătit',
  'Last Crawl': 'Ultima Scanare',
  'URLs Crawled': 'URL-uri Scanate',
  'URLs Selected': 'URL-uri Selectate',
  Never: 'Niciodată',
  'Batch Actions': 'Acțiuni în Lot',
  'Select All Checked': 'Selectează Toate Bifate',
  'Deselect All Checked': 'Deselectează Toate Bifate',
  'items selected': 'elemente selectate',
  'Search URLs, titles, descriptions...': 'Caută URL-uri, titluri, descrieri...',
  Search: 'Caută',
  Title: 'Titlu',
  Description: 'Descriere',
  'Crawl Time': 'Ora Scanării',
  Action: 'Acțiune',
  'N/A': 'N/A',
  'Please select at least one URL': 'Vă rugăm selectați cel puțin un URL',
  'Selected URLs have been marked as selected': 'URL-urile selectate au fost marcate ca selectate',
  'Selected URLs have been marked as deselected': 'URL-urile selectate au fost marcate ca neselectate',
  'Failed to update some URLs': 'Actualizarea unor URL-uri a eșuat',
  'Select all on current page': 'Selectează tot pe pagina curentă',
  'Select all filtered results': 'Selectează toate rezultatele filtrate',
  'Select all data': 'Selectează toate datele',
  'This operation would select all filtered results across all pages': 'Această operație ar selecta toate rezultatele filtrate din toate paginile',
  'Loading all IDs...': 'Se încarcă toate ID-urile...',
  'Loading filtered IDs...': 'Se încarcă ID-urile filtrate...',
  'Selected all {{count}} items': 'Selectate toate cele {{count}} elemente',
  'Selected all {{count}} filtered items': 'Selectate toate cele {{count}} elemente filtrate',
  'No items to select': 'Nu există elemente de selectat',
  'No items match the filter': 'Niciun element nu corespunde filtrului',
  'No filter applied': 'Niciun filtru aplicat',
  'Failed to get all IDs': 'Nu s-au putut obține toate ID-urile',
  'View Content': 'Vizualizare Conținut',
  'Page Content': 'Conținut Pagină',
  'No content available': 'Nu există conținut disponibil',
  'Loading content...': 'Se încarcă conținutul...',
  'Refresh Content': 'Reîmprospătează Conținutul',
  'Refreshing content for {{count}} pages...': 'Se reîmprospătează conținutul pentru {{count}} pagini...',
  'Content refreshed for {{count}} pages': 'Conținut reîmprospătat pentru {{count}} pagini',
  'Error refreshing some pages': 'Eroare la reîmprospătarea unor pagini',
  'Unable to fetch page content. The server may need to recrawl this URL.':
    'Nu se poate prelua conținutul paginii. Serverul ar putea avea nevoie să rescaneze acest URL.',
  'Error loading content': 'Eroare la încărcarea conținutului',
  Close: 'Închide',
  ResetToPending: 'Resetează la În așteptare',
  ResetItemsTooltip: 'Resetează elementele selectate la statusul În așteptare pentru reprocesare',
  PleaseSelectItemsToReset: 'Vă rugăm selectați elemente pentru resetare',
  ErrorResettingItems: 'Eroare la resetarea elementelor',
  ItemsResetSuccessfully: 'Elementele au fost resetate cu succes',
  'Indexing Status': 'Status Indexare',
  'Text Size': 'Dimensiune Text',
  Tokens: 'Tokeni',
  'Indexed At': 'Indexat La',
  'Knowledge Base Information': 'Informații Bază de Cunoștințe',
  'Last Indexed': 'Ultima Indexare',
  'Token Count': 'Număr de Tokeni',
  'OpenAI Storage': 'OpenAI Storage',
  Licitatii: 'Licitații',
  'Centralizator Licitatii': 'Centralizator Licitații',
  Refresh: 'Reciteste',
  Licitatie: 'Licitație',
  'Fetch SEAP': 'Preia SEAP',
  'Email Office365': 'Email Office365',
  'Emails Office365': 'Emails Office365',
  'Send to ERP': 'Trimite la ERP',
  'Actiuni': 'Actiuni',
  'Import': 'Import',
  'ERP': 'ERP',
  'ERP Connectors': 'Conectori ERP',
  'ERP Connector': 'Conector ERP',
}
